import type Big from 'big.js';
import round from 'lodash/round';

import {
  bigSumBy,
  toNumOrZero,
  formatCurrency,
  normalizePercentage,
  toBig,
} from '@cast/utils';

import { safeDivide } from 'utils/safeDivide';

import { ClusterRowModel, SummarySectionMetrics } from '../types';

export const getPercentage = (
  value: number | Big,
  valueOf: number | Big
): number => {
  return normalizePercentage(
    round(safeDivide(toBig(value).times(100), valueOf), 2)
  );
};

export const makeSummarySumBy =
  (data: ClusterRowModel[]) =>
  (key: keyof SummarySectionMetrics): Big => {
    return bigSumBy(data, ({ summaryMetrics }) => summaryMetrics[key]);
  };

export const renderPercent = (value?: number | string): string => {
  value = toNumOrZero(value);
  if (!value) {
    return '--%';
  }
  return `${round(normalizePercentage(value), 2)}%`;
};

export const renderCurrency = (value?: number | string): string => {
  value = toNumOrZero(value);

  const formatedValue = formatCurrency(value, {
    maximumFractionDigits: 2,
  });

  if (!value) {
    return formatedValue.replaceAll('00', '--').replaceAll('0', '--');
  }

  return formatedValue;
};
